import { alpha } from '@mui/system';
import { themeObject } from 'lib';

export const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        mt: '4px',
    },
    headingAndButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    headingTextStyles: {
        ...themeObject.typography.h2,
        fontSize: '26px',
        lineHeight: '30.52px',
        color: themeObject.palette.primary[700],
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
    },
    textButtonStyles: {
        backgroundColor: themeObject.palette.grayScale[50],
    },
    iconButtonStyles: {
        height: '30px',
        width: '30px',
        borderRadius: '48px',
        backgroundColor: themeObject.palette.background.default,
        boxShadow: `0px 1px 5px 0px ${alpha(
            themeObject.palette.grayScale[700],
            0.12
        )},0px 2px 2px 0px ${alpha(
            themeObject.palette.grayScale[700],
            0.14
        )},0px 3px 1px -2px ${alpha(themeObject.palette.grayScale[700], 0.2)}`,
        '&:hover, &:active': {
            backgroundColor: themeObject.palette.primary[50],
            boxShadow: `0px 1px 5px 0px ${alpha(
                themeObject.palette.grayScale[700],
                0.12
            )},0px 2px 2px 0px ${alpha(
                themeObject.palette.grayScale[700],
                0.14
            )},0px 3px 1px -2px ${alpha(themeObject.palette.grayScale[700], 0.2)}`,
        },
    },
    deleteMenuItemContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
    },
    deleteIconStyles: {
        color: themeObject.palette.tertiary.red[300],
    },
    deleteTextStyles: {
        ...themeObject.typography.Components.menuItem,
        lineHeight: '27px',
        color: themeObject.palette.grayScale[800],
    },
    unsavedChangesTextStyles: {
        ...themeObject.typography.captions.default,
        ...themeObject.typography.captions.medium,
        lineHeight: '15.88px',
        color: themeObject.palette.error[600],
    },
    executeContractIconStyles: {
        height: '20px',
        width: '22.12px',
        color: themeObject.palette.primary[400],
    },
    uploadIconStyles: {
        height: '24px',
        width: '24px',
        color: themeObject.palette.primary[400],
    },
    trunacteChainIconStyles: {
        height: '24px',
        width: '24px',
        color: themeObject.palette.tertiary.red[300],
    },
    dividerStyles: {
        color: themeObject.palette.grayScale[200],
    },
    trunacteChainIconMenuContainerStyles: {
        mt: 1,
    },
};

export const menuItemStyles = (width: string): any => {
    return {
        '& .MuiPaper-root': {
            width: width,
            borderRadius: '15px',
            boxShadow: `0px 3px 14px 2px ${alpha(
                themeObject.palette.grayScale[700],
                0.12
            )},0px 8px 10px 1px ${alpha(
                themeObject.palette.grayScale[700],
                0.14
            )}`,
            '& .MuiList-root': {
                my: '6px',
                '& .MuiButtonBase-root': {
                    width: '100%',
                },
            },
        },
    };
};
